import AuditTable from '~/pages/AuditHistory/AuditTable';
import { convertAuditEntityToAuditTableField } from '~/pages/AuditHistory/utils';

import AccordionContainer from '../../common/components/AccordionContainer';

type AuditHistoryAccordionProps = {
  entity: {
    entityDisplayName?: string;
  };
};

const AuditHistoryAccordion = ({
  entity,
}: Readonly<AuditHistoryAccordionProps>) => {
  return (
    <AccordionContainer
      header={entity.entityDisplayName}
      allowToggle
      defaultIndex={[-1]}
      layoutType={'summary1003AuditHistory'}
      marginTop="unset"
      accordionButtonProps={{
        padding: '1rem',
        accordionBgExpanded: 'blue.50',
      }}
      accordionPanelProps={{
        paddingLeft: '1rem',
        paddingRight: '1rem',
        padding: '1.5rem 1rem',
      }}
    >
      <AuditTable
        data={convertAuditEntityToAuditTableField(entity)}
        section={{}}
      />
    </AccordionContainer>
  );
};

export default AuditHistoryAccordion;
